<template>
  <div class="buildingDetail">
    <div class="titleWrap">
      <div class="setTitle">{{ buildingName }}栋</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/villageDetail?id=' + villageId + '&villageName=' + encodeURI(encodeURI(villageName)) + '&villageAddress=' + encodeURI(encodeURI(villageAddress)) }">{{ villageName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ buildingName }}栋详情</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- <div class="totalCount">
        共 <span class="number">{{ unitTotal }}</span> 个单元，<span class="number">{{ userTotal }}</span> 个住户，<span class="number">{{ liftTotal }}</span> 台电梯(年检 <span class="number">{{ checkTotal }}</span> 台，保养 <span class="number">{{ maintainTotal }}</span> 台)，多媒体素材 <span class="number">{{ multimediaTotal }}</span> 台，一梯一档 <span class="number">{{ oneLiftTotal }}</span> 份
      </div> -->
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <template v-for="(obj, index) in buildingAttr">
        <div class="unitDiv" :key="index + '_1'">
          <span class="unitName">{{ obj.unit }}单元</span>共 <span class="liftNumber">{{ obj.liftList.length }}</span> 台
        </div>
        <el-row class="myRow" :key="index + '_2'">
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="12" class="mycol" v-for="item in obj.liftList" :key="item.id">
            <div class="contentWrap" @click="detail(item.id, item.sn)">
              <div class="liftImage"></div>
              <div class="liftSN">{{ notData(item.sn) }}</div>
              <div class="clearfix"></div>
              <div class="liftFile">一梯一档：<span class="liftFileNumber">{{ item.fileCount }}</span> <span style="color: #333;">份</span></div>
            </div>
          </el-col>
        </el-row>
      </template>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'BuildingDetail',
  data () {
    return {
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageAddress: '', // 小区地址
      buildingName: '', // 楼宇名称
      unitTotal: 0, // 单元总数
      userTotal: 0, // 住户总数
      liftTotal: 0, // 电梯总数
      checkTotal: 0, // 年检总数
      maintainTotal: 0, // 保养总数
      multimediaTotal: 0, // 多媒体素材总数
      oneLiftTotal: 0, // 一梯一档总数
      buildingAttr: [] // 楼宇列表
    }
  },
  mounted () {
    // 小区Id
    this.villageId = this.$route.query.villageId
    // 小区名称
    this.villageName = decodeURI(decodeURI(this.$route.query.villageName))
    // 小区地址
    this.villageAddress = decodeURI(decodeURI(this.$route.query.villageAddress))
    // 楼宇名称
    this.buildingName = decodeURI(decodeURI(this.$route.query.buildingName))

    // 获取电梯列表
    this.getLiftList()
  },
  methods: {
    getLiftList () {
      this.$http.get(this.$api.lift_info, {
        params: {
          orgId: this.villageId,
          building: this.buildingName
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          for (let i in data.data.data) {
            this.buildingAttr.push({
              unit: i,
              liftList: data.data.data[i]
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    detail (id, sn) {
      this.$router.push('liftDetail?liftId=' + id + '&liftSN=' + sn + '&buildingName=' + encodeURI(encodeURI(this.buildingName)) + '&villageId=' + this.villageId + '&villageName=' + encodeURI(encodeURI(this.villageName)) + '&villageAddress=' + encodeURI(encodeURI(this.villageAddress)))
    },
    notData (str) {
      return this.$null(str)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.buildingDetail
  box-sizing border-box
  padding 80px 0 0 20px
  width 100%
  min-height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 48px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .el-breadcrumb
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 12px
    .totalCount
      float right
      margin-right 20px
      height 32px
      line-height 32px
      font-size 14px
      color #333
      .number
        color #F02B54
  .tableWrap
    padding 0
    border-radius 4px
    .unitDiv
      height 20px
      line-height 20px
      font-size 14px
      color #333
      .unitName
        margin-right 24px
        font-size 16px
        font-weight bold
      .liftNumber
        font-weight bold
        color #F02B54
    .myRow
      padding-bottom 32px
      overflow hidden
      .mycol
        margin-top 20px
        padding-right 20px
        min-width 270px
        .contentWrap
          box-sizing border-box
          position relative
          width 100%
          height 102px
          background-color #fff
          box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
          border-radius 4px
          cursor pointer
          &:hover
            box-shadow 0 3px 10px 0 rgba(31, 145, 243, .4)
          .liftImage
            float left
            margin 8px
            margin-bottom 0
            width 56px
            height 56px
            background-image url('../../assets/img/lift_color.png')
            background-repeat no-repeat
            background-size 100% 100%
          .liftSN
            float left
            margin-top 8px
            height 56px
            line-height 56px
            font-size 16px
            font-weight bold
            color #333
          .liftFile
            line-height 18px
            font-size 14px
            color #666
            text-align center
            .liftFileNumber
              color #60ACFC
</style>



// WEBPACK FOOTER //
// src/components/village/buildingDetail.vue